'use es6';

import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import * as AppContext from '../constants/AppContext';
import { isProd } from '../utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
export const getAppContext = state => state.app.appContext;
const coreTypeMap = {
  [AppContext.IN_APP]: 'app',
  [AppContext.PUBLIC]: 'public'
};
export function getAppContextCoreType(state) {
  return coreTypeMap[state.app.appContext];
}
export const getTrackingParams = state => state.app.trackingParams;
export const getIsPublicApp = createSelector([getAppContext], appContext => appContext === AppContext.PUBLIC);
export function PublicAppComponent({
  children
}) {
  const isPublicApp = useSelector(getIsPublicApp);
  return isPublicApp ? /*#__PURE__*/_jsx(Fragment, {
    children: children
  }) : null;
}
export const getCanonicalAppContext = createSelector([getAppContext, getIsPublicApp], (appContext, isPublicApp) => {
  if (isPublicApp && isProd()) {
    return AppContext.PUBLIC;
  }
  return appContext;
});